export const IMAGES = {
  LANDING_BANNER: require("../../assets/images/landing-banner.png"),
  SIGNUP_SUCCESS: require("../../assets/images/landing-banner.png"),
  // New brand lockup (redesign) — the old raster mark lives at images/tp-logo.png.
  // .default: CRA 5 exposes SVGs as ES modules (unlike the CJS-shaped PNG loader).
  TP_LOGO: require("../../assets/images/brand/tenantport-lockup.svg").default,
  CREDIT_BUILDER: require("../../assets/images/creditbuilder.png"),
};

export const EmptyStates = {
  aprroved: require("../../assets/images/status/empty-states/aprroved.png"),
};

export const RENT_IMAGES = {
  INFO_BANNER: require("../../assets/images/rent/info_banner.png"),
  CONFIRMATION_BANNER: require("../../assets/images/rent/confirmation_banner.png"),
};

export const IDENTITY_IMAGES = {
  APPROVED: require("../../assets/images/identity/identity_approved.png"),
  FAILED: require("../../assets/images/identity/identity_failed.png"),
  VERIFY: require("../../assets/images/identity/verify_identity.png"),
};
